/* eslint-env node */
// Shared by Web and uni-app. The backend owns role resolution and permission grants.
var ROLE_CODE = {
  BUSINESS: 'BUSINESS', ADMIN: 'ADMIN', LEADER: 'LEADER', WORKER: 'WORKER', CUSTOMER: 'CUSTOMER'
};

function hasPermission(user, permission) {
  return !!user && Array.isArray(user.permissions) && user.permissions.indexOf(permission) !== -1;
}

function hasRole(user, code) {
  return !!user && Array.isArray(user.roleCodes) && user.roleCodes.indexOf(code) !== -1;
}

function getUserRole(user) {
  var role = user && user.homeRole;
  return ['business', 'admin', 'leader', 'worker', 'customer'].indexOf(role) === -1 ? 'none' : role;
}

function isBusiness(user) { return hasRole(user, ROLE_CODE.BUSINESS); }
function isAdmin(user) { return hasRole(user, ROLE_CODE.ADMIN); }
function isLeader(user) { return hasRole(user, ROLE_CODE.LEADER); }
function isRepairman(user) { return hasRole(user, ROLE_CODE.WORKER); }
function isCustomer(user) { return getUserRole(user) === 'customer'; }
function canManageRepairs(user) { return hasPermission(user, 'repair:manage'); }
function canDispatch(user) { return hasPermission(user, 'repair:dispatch'); }
function canReview(user) { return hasPermission(user, 'repair:review'); }
function canRecall(user) { return hasPermission(user, 'repair:recall'); }
function canViewRepairAmount(user) { return hasPermission(user, 'repair:viewAmount'); }

function getHomePage(user) {
  var pages = {
    business: '/pages/roles/business', admin: '/pages/roles/admin',
    leader: '/pages/roles/leader', worker: '/pages/roles/repairman', customer: '/pages/index/index'
  };
  return pages[getUserRole(user)] || '/pages/index/index';
}

module.exports = {
  ROLE_CODE: ROLE_CODE,
  hasPermission: hasPermission,
  hasRole: hasRole,
  getUserRole: getUserRole,
  isBusiness: isBusiness,
  isAdmin: isAdmin,
  isLeader: isLeader,
  isRepairman: isRepairman,
  isCustomer: isCustomer,
  canManageRepairs: canManageRepairs,
  canDispatch: canDispatch,
  canReview: canReview,
  canRecall: canRecall,
  canViewRepairAmount: canViewRepairAmount,
  getHomePage: getHomePage
};



//////////////////
// WEBPACK FOOTER
// ../shared/access.js
// module id = dD7C
// module chunks = 94